import Vue from 'vue'
import VueRouter from 'vue-router'
import authentication from './auth'
import Config from "../../config-app/config";

Vue.use(VueRouter)


const routes = [{
    path: '/login',
    alias: '/logout',
    component: require('../components/views/LoginRouter.vue').default,
    meta: {
      auth: false
    }
  },
  {
    path: '/login-developer',
    component: require('../components/views/LoginDeveloper.vue').default,
    meta: {
      auth: false
    }
  },
  {
    path: '/display-name',
    component: require('../components/views/DisplayName.vue').default,
    meta: {
      auth: true
    }
  },
  {
    path: '',
    alias: '/',
    component: require('../components/views/HomeRouter.vue').default,
  },
  {
    path: '/crea-asta',
    component: require('../components/views/CreaAsta.vue').default,
    meta: {
      auth: true
    }
  },
  {
    path: '/reset',
    component: require('../components/views/Reset.vue').default,
    meta: {
      auth: true
    }
  },
  // {
  //   path: '/asta',
  //   component: require('../components/views/Main.vue').default,
  //   meta: {
  //     auth: true
  //   }
  // },
  {
    path: '/asta/:id',
    name: 'asta',
    component: require('../components/views/Main.vue').default,
    meta: {
      auth: true,
    }
  },
  {
    path: '/sblocca/:asta_id',
    name: 'pagamento',
    component: require('../components/views/Pagamento.vue').default,
  },
  {
    path: '/invito-asta/:pass',
    name: 'invito',
    component: require('../components/views/IscriviSquadra.vue').default,
    meta: {
      auth: true
    }
  },
  {
    path: '*',
    component: require('../components/views/NotFound.vue').default,
  }
]

const router = new VueRouter({
  base: __dirname,
  routes: routes
})

// dopo logged-in:     :  pusho su redirect o '/' nel login stesso
// dopo il logged-auth :  pusho su '/' nell onAuthChange
// Durante nagigazione :  la gestisco qui nel router 

router.beforeEach((to, from, next) => {
  handleBeforeEach(to, from, next)
})

async function handleBeforeEach(to, from, next) {

  // os
  const os = to.query.os;
  if (os !== undefined) {
    // console.log('--- os', os)
    window.os = os
    const newQuery = { ...to.query };
    delete newQuery.os;
    next({ ...to, query: newQuery });
  }

  const user_uid = authentication.getUserId();

  // console.log('--- to.path', to.path)

  // true / false / null (indifferente)
  let authMandatory = null
  if (to.hasOwnProperty('meta')) {
    if (to.meta.hasOwnProperty('auth')) {
      authMandatory = to.meta.auth
    }
  }

  if (authMandatory === null) {
    // indifferente
    // console.log('route indifferente')

    if (!Config.STANDALONE) {
      // workaround caso '/'
      // Siccome in prod i fragment nn vengono passati su alcuni browser
      // => asta live deve aprirsi in qualche modo dalla root '/' 
      // (che viene gestita qui in quanto "indifferente")
      if (to.path == '/' || to.path == '') {
        // console.log('workaround fantapazz -> signInUserWithToken')
        // tento di loggare
        const token = window.firebase ? window.firebase.token : null
        if (token) {
          await authentication.signInUserWithToken(token)
        }
        // altrimenti Home si occuperà di mostrare un messaggio di uscire e rientrare
      }
    }
    next();
  } else {

    // solo loggati
    if (authMandatory) {
      // console.log('route solo x loggati')
      // se si è loggati...
      if (user_uid) {
        // console.log('loggato')
        // ... controlla se deve impostare uno username
        if (Config.FORCE_DISPLAY_NAME) {
          const displayName = authentication.getDisplayName();
          //  console.log('displayName', displayName)
          if (!displayName && to.path != '/display-name') {
            //  console.log('forza display-name')
            next({
              path: '/display-name',
              query: {
                redirect: to.path,
              },
            });
          }
        }
        next()
      } else {
        // console.log('non loggato')
        // ...altrimenti redirect a /login 
        // (a meno che nn ci sei già???)

        // ECCEZIONE Fantapazz: Ma prima tento di auto loggarlo!
        // nel qual caso lo faccio procedere
        // succede per asta/xxx fantapazz nel caso di non loggati
        if (!Config.STANDALONE) {
          // console.log('caso asta/xxx fantapazz -> signInUserWithToken')

          const token = window.firebase ? window.firebase.token : null
          if (token) {
            const isLogged = await authentication.signInUserWithToken(token)
            if (isLogged) {
              next()
            }
          }
        }
        // console.log('caso standalone -> /login')
        next({
          path: '/login',
          query: {
            redirect: to.path,
          },
        });
      }

    } else {
      // console.log('route x non loggati')
      // solo non loggati
      if (!user_uid) {
        // console.log('non loggato')
        next()
      } else {
        // console.log('loggato')
        next({
          path: '/',
        })
      }
    }
  }
}

export default router